import { useCallback, useEffect } from 'react';

import { DefaultOptionType } from 'antd/es/select';
import { Form, FormItemProps, Select, SelectProps } from 'antd';

interface SelectFormProps {
  formProps?: FormItemProps;
  selectProps?: SelectProps;
  allowAutoSelect?: boolean;
}

export const SelectForm = ({ formProps, selectProps, allowAutoSelect = true }: SelectFormProps) => {
  const form = Form.useFormInstance();

  const setInitialValue = useCallback(() => {
    const currentValue = form.getFieldValue(formProps?.name);

    if (
      selectProps?.options && 
      selectProps?.options?.length === 1 &&
      currentValue !== selectProps.options[0].value
    ) {
      form.setFieldValue(formProps?.name, selectProps?.options[0].value);
      if(selectProps.onSelect) {
        selectProps.onSelect(selectProps?.options[0].value, selectProps?.options[0]);
      }
      if(selectProps.onChange) {
        selectProps.onChange(selectProps?.options[0].value, selectProps?.options[0]);
      }
    }
  }, [form, formProps, selectProps]);

  useEffect(() => {
    if(allowAutoSelect){
      setInitialValue();
    }
  }, [setInitialValue, allowAutoSelect]);

  return (
    <Form.Item 
      {...formProps}
      hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
    >
      <Select
        filterSort={(optionA: DefaultOptionType, optionB: DefaultOptionType) =>
          String(optionA?.label ?? '')
            .toLowerCase()
            .localeCompare(String(optionB?.label ?? '').toLowerCase())
        }
        optionFilterProp='label'
        {...selectProps}
        placeholder={selectProps?.placeholder ?? 'Seleccionar'}
      />
    </Form.Item>
  );
};
